<template>
    <div class="h-m-login-blog-post">
        <h2 class="post-title text-white mb-4">{{ title }}</h2>
        <a v-show="title && link" class="read-more text-white" :href="link" target="_blank">
            Saiba mais <i class="fas fa-external-link-square-alt ml-1"></i>
        </a>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                title: '',
                link: '',
                loading: false,
            }
        },
        mounted()
        {
            this.loading = true;

            this.$api.get('https://help-admin.hostoo.io/feed/', {
                    headers: {
                        'Accept': 'text/xml'
                    },
                    transformRequest: [
                        function (data, headers) {
                            delete headers['X-Requested-With'];
                            return data;
                        }
                    ],
                })
                .then(response => {
                    let parser, xmlDoc;

                    if (typeof window.DOMParser !== 'undefined')
                    {
                        parser = new DOMParser();
                        xmlDoc = parser.parseFromString(response.data, "text/xml");
                    }
                    else // Internet Explorer
                    {
                        xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
                        xmlDoc.async = false;
                        xmlDoc.loadXML(response.data);
                    }

                    const items = xmlDoc.getElementsByTagName('item');

                    if (items && items.length)
                    {
                        const selected = Math.floor((Math.random() * items.length));
                        this.title = items.item(selected).getElementsByTagName('title')[0].childNodes[0].nodeValue;

                        const slugPost = (items.item(selected).getElementsByTagName('link')[0].childNodes[0].nodeValue.split("/article/"))[1]
                        this.link  = `https://help.hostoo.io/article/${slugPost}`;
                    }
                })
                .catch(error => {
                    this.title = 'Conheça a nossa Central de Ajuda e tire as suas dúvidas';
                    this.link  = 'https://help.hostoo.io/';
                })
                .then (() => this.loading = false);
        }
    }
</script>

<style lang="stylus">
    .h-m-login-blog-post
        max-width 360px

        .post-title
            font-weight bold

        .read-more
            font-size 1.125rem
            text-transform uppercase
            opacity .5
</style>